import { InputBaseComponentProps } from '@mui/material';
import React, { ChangeEvent } from 'react';
import { IMaskInput } from 'react-imask';

const ExpirationDateField = React.forwardRef<
  HTMLInputElement,
  InputBaseComponentProps
>(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="##/##"
      placeholder="MM/YY"
      definitions={{
        '#': /[0-9]/,
      }}
      inputRef={ref as any}
      onAccept={(value: any) => {
        return (
          onChange &&
          onChange({
            target: { name: props.name, value },
          } as ChangeEvent<HTMLInputElement>)
        );
      }}
      style={{
        fontKerning: 'none',
      }}
      overwrite
    />
  );
});

export default ExpirationDateField;
